import { render, staticRenderFns } from "./Funcionalidade.vue?vue&type=template&id=3ae90264&"
import script from "./Funcionalidade.vue?vue&type=script&lang=js&"
export * from "./Funcionalidade.vue?vue&type=script&lang=js&"
import style0 from "./Funcionalidade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports